import React, { ReactElement } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./sidebaraccordioncard.module.scss";

import SidebarMenuItem from "../models/SidebarMenuItem";
import { Accordion, Card } from "react-bootstrap";

import ISidebarService from "../services/ISidebarService";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { useTranslation } from "react-i18next";
import Icon from "features/shared/components/icons/Icon";

interface IProps {
  menuItem: SidebarMenuItem;
  activeCardId: string;
}

const SidebarAccordionCard: React.FC<IProps> = (props) => {
  // translation
  const { t } = useTranslation("shared\\moduleNames");
  // DI
  const sidebarService = useInjection<ISidebarService>(IocTypes.SidebarService);
  // props destructing
  const { menuItem, activeCardId } = props;

  const renderCardLinks = (
    items: Array<SidebarMenuItem>
  ): Array<ReactElement> => {
    return items.map((item) => (
      <NavLink
        to={sidebarService.getRouteWithParams(item.routePath, item.routeParams)}
        exact
        className={`list-group-item list-group-item-action ${styles.sidebarSubLink}`}
        activeClassName={styles.sidebarSubLinkActive}
        key={item.id}
      >
        {t(item.title)}
      </NavLink>
    ));
  };

  const treeLinkClasses = (actualCardId: string, activeCardId: string) => {
    let activeClass = actualCardId == activeCardId ? ` ${styles.sidebarTreeLinkActive}` : "";
    return `${styles.sidebarTreeLink}${activeClass}`;
  };

  return (
    <>
      <Accordion.Toggle
        as={Card.Header}
        className={treeLinkClasses(menuItem.id, activeCardId)}
        variant="link"
        eventKey={menuItem.id}
      >
        <span className={styles.sidebarLinkIcon}>
          <Icon icon={menuItem.icon!} />
        </span>
        <span className={styles.sidebarLinkText}>{menuItem.title}</span>
        <span className={styles.sidebarLinkArrow}>
          <FontAwesomeIcon icon="chevron-down" />
        </span>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={menuItem.id}>
        <Card.Body className="p-0">
          <div className={`list-group ${styles.sidebarSubMenu}`}>
            {renderCardLinks(menuItem.childItems!)}
          </div>
        </Card.Body>
      </Accordion.Collapse>
    </>
  );
};

export default SidebarAccordionCard;
